module.exports = __webpack_public_path__ + "static/media/AutoCAD for Mac Experience.be04a10d.png";